import React from 'react';

export default function Checkmark({ className }) {
  return (
    <svg viewBox='0 0 41.89 31.57' className={className}>
      <g id='upload_img_icon' data-name='upload img icon'>
        <path d='M40.58,1.32c-1.76-1.76-4.61-1.76-6.36,0L14.74,20.79l-7.06-7.06c-1.76-1.76-4.61-1.76-6.36,0s-1.76,4.61,0,6.36l10.16,10.16c1.61,1.61,4.13,1.73,5.89,.38,.34-.19,.66-.42,.95-.7L40.58,7.68c1.76-1.76,1.76-4.61,0-6.36Z' />
      </g>
    </svg>
  );
}
